const colors = {
  teamA: '#b34045',
  teamB: '#4091d7',
};

export default colors;
